import React from 'react';
import { Building2, ShieldCheck, Route, Ship, Train, Truck, Plane } from 'lucide-react';

export default function About() {
  return (
    <div className="bg-[#f8fafc] font-[IRANSansWeb,Tahoma] p-6 md:p-10" dir="rtl">
      <div className="max-w-6xl mx-auto space-y-8">
        <header className="bg-white rounded-[2.5rem] border border-gray-100 shadow-sm p-8 md:p-10 overflow-hidden relative">
          <div className="absolute inset-0 opacity-40 bg-[radial-gradient(circle_at_top,rgba(33,57,112,0.10),transparent_70%)]" />
          <div className="relative">
            <div className="inline-flex items-center gap-2 bg-blue-50 text-blue-700 px-4 py-2 rounded-2xl text-[11px] font-extrabold border border-blue-100">
              <Building2 size={16} />
              <span>درباره سامانه</span>
            </div>

            <h1 className="mt-6 text-3xl md:text-4xl font-black text-[#1A3062] leading-tight">
              کریدور هوشمند شمال - جنوب
            </h1>

            <p className="mt-4 text-sm text-gray-500 leading-8 max-w-3xl">
              این سامانه یک درگاه یکپارچه برای مدیریت لجستیک، حمل‌ونقل چندوجهی، تجارت فرامرزی و دسترسی به فرصت‌های
              سرمایه‌گذاری در مسیر راهبردی جنوب به شمال است. هدف ما کاهش زمان، هزینه و خطا در فرایندهای عملیاتی و افزایش
              شفافیت و قابلیت رهگیری است.
            </p>
          </div>
        </header>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <section className="lg:col-span-2 bg-white rounded-[2.5rem] border border-gray-100 shadow-sm p-8">
            <div className="flex items-start justify-between gap-6">
              <div className="text-right">
                <h2 className="text-lg font-black text-gray-800">ماموریت ما</h2>
                <p className="text-[11px] text-gray-400 mt-2 leading-7">
                  ایجاد یک تجربه یکپارچه از ثبت درخواست تا رهگیری، برای کسب‌وکارهای تجاری، شرکت‌های حمل‌ونقل و
                  سرمایه‌گذاران.
                </p>
              </div>
              <div className="w-12 h-12 rounded-2xl bg-blue-50 border border-blue-100 flex items-center justify-center text-blue-700">
                <Route size={22} />
              </div>
            </div>

            <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-4">
              <Card
                icon={<ShieldCheck size={18} className="text-blue-700" />}
                title="شفافیت و انطباق"
                desc="یکپارچه‌سازی مراحل، کاهش رفت‌وبرگشت‌های اداری، و افزایش قابلیت کنترل و گزارش‌گیری."
              />
              <Card
                icon={<Route size={18} className="text-blue-700" />}
                title="بهینه‌سازی مسیر"
                desc="مقایسه سناریوهای مسیر/زمان/هزینه و پیشنهاد مسیرهای چندوجهی بر اساس نوع کالا."
              />
              <Card
                icon={<Building2 size={18} className="text-blue-700" />}
                title="توانمندسازی سرمایه‌گذاری"
                desc="دسترسی به پروژه‌ها، مدل‌های مشارکت، مجوزها و ثبت علاقه‌مندی برای توسعه زیرساخت."
              />
              <Card
                icon={<ShieldCheck size={18} className="text-blue-700" />}
                title="پشتیبانی عملیاتی"
                desc="راهنماها، چک‌لیست‌ها و پاسخ‌های سریع برای کاهش خطا در عملیات تجارت و حمل‌ونقل."
              />
            </div>
          </section>

          <aside className="bg-white rounded-[2.5rem] border border-gray-100 shadow-sm p-8">
            <div className="text-right">
              <h3 className="text-lg font-black text-gray-800">مدهای حمل تحت پوشش</h3>
              <p className="text-[11px] text-gray-400 mt-2 leading-7">
                پشتیبانی از حمل دریایی، ریلی، جاده‌ای و هوایی (کارگو) و ترکیب آن‌ها در سناریوهای چندوجهی.
              </p>
            </div>

            <div className="mt-8 space-y-3">
              <Mode icon={<Ship size={18} />} title="دریایی" desc="مناسب بارهای حجیم و اقتصادی" />
              <Mode icon={<Train size={18} />} title="ریلی" desc="پایدار و مناسب ترانزیت" />
              <Mode icon={<Truck size={18} />} title="جاده‌ای" desc="انعطاف‌پذیر برای درب-به-درب" />
              <Mode icon={<Plane size={18} />} title="هوایی (کارگو)" desc="سریع برای بارهای حساس" />
            </div>
          </aside>
        </div>
      </div>
    </div>
  );
}

function Card({ icon, title, desc }) {
  return (
    <div className="rounded-2xl border border-gray-100 bg-[#fbfdff] p-5 hover:shadow-sm transition">
      <div className="flex items-center gap-2">
        <div className="w-10 h-10 rounded-2xl bg-blue-50 border border-blue-100 flex items-center justify-center">
          {icon}
        </div>
        <div className="text-sm font-extrabold text-gray-800">{title}</div>
      </div>
      <div className="text-[11px] text-gray-400 mt-2 leading-7">{desc}</div>
    </div>
  );
}

function Mode({ icon, title, desc }) {
  return (
    <div className="flex items-center justify-between gap-4 p-4 rounded-2xl border border-gray-100 bg-[#fbfdff] hover:shadow-sm transition">
      <div className="text-right min-w-0">
        <div className="text-sm font-extrabold text-gray-800">{title}</div>
        <div className="text-[11px] text-gray-400 mt-1 leading-7">{desc}</div>
      </div>
      <div className="w-10 h-10 rounded-2xl bg-blue-50 border border-blue-100 flex items-center justify-center text-blue-700 flex-shrink-0">
        {icon}
      </div>
    </div>
  );
}

